import ConfigService from 'shared/services/config.service';

export const dateConfigurations = JSON.parse(ConfigService.getConfigValue('Settings', 'DateConfigs') || '[]') as [];
